module.exports = __webpack_public_path__ + "static/img/sm_23.244c184.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_23.png
// module id = xbvV
// module chunks = 0